import { render, staticRenderFns } from "./myApp.vue?vue&type=template&id=4a1c4bce&"
import script from "./myApp.vue?vue&type=script&lang=js&"
export * from "./myApp.vue?vue&type=script&lang=js&"
import style0 from "./myApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports